import React, {useEffect, useState} from 'react';

const NewRender = (props) => {
	useEffect(() => {
		fetch(global.config.server_path + "saved_design/get_one/", {
		  "headers": {
		    "accept": "*/*",
		    "accept-language": "en-US,en;q=0.9,hi;q=0.8,fr;q=0.7",
		    "content-type": "application/json",
		    "sec-ch-ua": "\"Google Chrome\";v=\"87\", \" Not;A Brand\";v=\"99\", \"Chromium\";v=\"87\"",
		    "sec-ch-ua-mobile": "?0",
		    "sec-fetch-dest": "empty",
		    "sec-fetch-mode": "cors",
		    "sec-fetch-site": "same-site"
		  },
		  "referrer": "http://localhost:3000/",
		  "referrerPolicy": "origin",
		  "body": "{\"id\":\""+props.match.params.id+"\"}",
		  "method": "POST",
		  "mode": "cors",
		  "credentials": "include"
		}).then(o => o.json()).then(o => {
			// var b = new window.DM_Design();
			// b.design_save_id = o.data._id;
			// b.load(o.data.design_file);
			// b.draw();
			// window.b = b;
			// document.getElementById("design_container").appendChild(b.doms[0])
			var b = new window.DM_Editor(o.data.design_file,o.data._id,document.getElementById("design_container"));
			window.b = b;
			b.draw();
		})
	}, [])

	window.print_this = () => {
		// var doc = new window.jsPDF();
	 //    var specialElementHandlers = {
	 //        '#editor': function (element, renderer) {
	 //            return true;
	 //        }
	 //    };
  //       doc.fromHTML(window.$(window.b.design.doms[0]).html());
  //       doc.save('sample-file.pdf');
        window.html2canvas(window.b.design.doms[0]).then(canvas => {
        	console.log(canvas.toDataURL());
		    // document.body.appendChild(canvas)
		});
	}

	return (
		<div id="design_container">
		</div>
	);

}

export default NewRender;